import API_BASE_URL from '../Config';

const API_URL = `${API_BASE_URL}/mantenimiento/cajas`;

export const getCajasPaginadas = async (token, page = 0, size = 10, search = '', sucursalId = '') => {
    let url = `${API_URL}/page?page=${page}&size=${size}&search=${search}`;
    if (sucursalId) url += `&sucursalId=${sucursalId}`;
    
    const response = await fetch(url, {
        headers: { 'Authorization': `Bearer ${token}` }
    });
    if (!response.ok) throw new Error('Error al cargar cajas paginadas');
    return response.json();
};

export const getCajaById = async (token, id) => {
    const response = await fetch(`${API_URL}/${id}`, {
        headers: { 'Authorization': `Bearer ${token}` }
    });
    if (!response.ok) throw new Error('Error al obtener la caja');
    return response.json();
};

export const createCaja = async (token, data) => {
    const response = await fetch(API_URL, {
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    });
    if (!response.ok) throw new Error('Error al crear caja');
    return response.json();
};

export const updateCaja = async (token, id, data) => {
    const response = await fetch(`${API_URL}/${id}`, {
        method: 'PUT',
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    });
    if (!response.ok) throw new Error('Error al actualizar caja');
    return response.json();
};

export const deleteCaja = async (token, id) => {
    const response = await fetch(`${API_URL}/${id}`, {
        method: 'DELETE',
        headers: { 'Authorization': `Bearer ${token}` }
    });
    if (!response.ok) throw new Error('Error al eliminar caja');
    return true;
};
